import { Modal } from "@mantine/core"
import { useForm } from "@mantine/form"
import { showNotification } from "@mantine/notifications"
import type { Prisma } from "@tfg/db"
import { zod4Resolver } from "mantine-form-zod-resolver"
import { useTranslation } from "react-i18next"

import { FAQInputSchema } from "@tfg/types/schemas/faq"

import { FAQForm } from "./FAQForm"
import { useCreateFAQMutation } from "./hooks"

type Props = {
  opened: boolean
  onClose: () => void
}

export const FAQCreationModal = ({ opened, onClose }: Props) => {
  const { t } = useTranslation("admin")

  const {
    mutateAsync,
    isPending: isLoading,
    error,
  } = useCreateFAQMutation({
    onSuccess: () => {
      showNotification({
        color: "green",
        message: t("faq.modal.create.success"),
      })
      form.reset()
      onClose()
    },
  })

  const form = useForm<Prisma.FAQCreateInput>({
    validate: zod4Resolver(FAQInputSchema),
  })

  return (
    <Modal
      title={t("faq.modal.create.title")}
      opened={opened}
      onClose={onClose}
    >
      <FAQForm
        form={form}
        onSubmit={mutateAsync}
        isLoading={isLoading}
        error={error}
      />
    </Modal>
  )
}
